import { Box } from "@mui/material";
import React from "react";
import DashBoardAnalytics from "./DashBoardAnalytics";

const Dashboard = () => {
  return (
    <>
      <Box m="1.5rem 2.5rem">
      <DashBoardAnalytics />
      </Box>
    </>
  );
};

export default Dashboard;
